import { ClipboardList, Users } from "lucide-react";
import { cn } from "@/lib/cn";

export type LenteDosPedidos = "todos" | "profissional";

/**
 * "Todos os pedidos" × "Por dentista" num botão só, no celular. Mostra o ícone do modo ATUAL
 * (lista ou pessoas) e fica azul no "Por dentista" — o modo fora do padrão precisa se fazer
 * notar, senão a pessoa não percebe que está numa visão agrupada.
 */
export function BotaoLente({ lente, onChange }: { lente: LenteDosPedidos; onChange: (l: LenteDosPedidos) => void }) {
  const porProfissional = lente === "profissional";
  return (
    <button
      type="button"
      onClick={() => onChange(porProfissional ? "todos" : "profissional")}
      aria-pressed={porProfissional}
      aria-label={porProfissional ? "Vendo por dentista — tocar pra ver todos os pedidos" : "Vendo todos os pedidos — tocar pra ver por dentista"}
      title={porProfissional ? "Por dentista" : "Todos os pedidos"}
      className={cn(
        "flex h-11 w-11 shrink-0 items-center justify-center rounded-md border transition-colors",
        porProfissional
          ? "border-brand-600 bg-brand-600 text-white"
          : "border-zinc-200 bg-white text-zinc-600 hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground",
      )}
    >
      {porProfissional ? <Users className="h-5 w-5" /> : <ClipboardList className="h-5 w-5" />}
    </button>
  );
}
